import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Checkbox from './Checkbox';
import Tooltip from '@mui/material/Tooltip';
import { IconButton } from '@mui/material';

const HeaderCheckboxes = (
  { totalColums, cookieTable, cookieName, updateColums, customActions = [], lan }) => {
  const [checkboxes, setCheckboxes] = useState({});
  const [showCheckBoxes, setShowCheckBoxes] = useState(false);
  useEffect(() => {
    const initialCheckboxes = totalColums.reduce((options, option) => {
      return { ...options, [option.key]: obtainKeys(option.key) };
    }, {});
    setCheckboxes(initialCheckboxes);
  }, [totalColums]);
  const obtainKeys = (keyValue) => {
    const cookieObtain = cookieTable.get(cookieName);
    return cookieObtain ? cookieObtain.includes(keyValue) : undefined;
  };
  const selectAllCheckboxes = (isSelected) => {
    const updated = { ...checkboxes };
    Object.keys(updated).forEach((key) => {
      if (key !== 'iconWarning' && key !== 'icon') updated[key] = isSelected;
    });
    setCheckboxes(updated);
  };
  const selectAll = () => selectAllCheckboxes(true);
  const handleCheckboxChange = (changeEvent) => {
    const { name } = changeEvent.target;
    const id = document.getElementsByClassName(name)[0].id;
    setCheckboxes((prev) => ({ ...prev, [id]: !prev[id] }));
  };
  const handleFormSubmit = (formSubmitEvent) => {
    formSubmitEvent.preventDefault();
    let conca = '';
    Object.keys(checkboxes)
      .filter((checkbox) => checkboxes[checkbox])
      .forEach((checkbox) => {
        conca = conca.concat(checkbox + ' ');
      });
    cookieTable.set(cookieName, conca.trimRight(), { path: '/' });
    updateColums();
  };
  const createCheckbox = (option) => {
    if (option.key !== 'iconWarning' && option.key !== 'icon') {
      return (
        <div className='checkbox col-sm-3 d-flex justify-content-start' key={option.key}>
          <Checkbox
            label={option.name}
            isSelected={checkboxes[option.key]}
            onCheckboxChange={handleCheckboxChange}
            keyN={option.key}
            key={option.key}
          />
        </div>
      );
    }
    return null;
  };
  const createCheckboxes = () => totalColums.map(createCheckbox);
  const renderActionButtons = () => (
    <>
      {customActions.map((action, key) => (
        <Tooltip arrow title={action.toolTip || 'Aux action'}>
          <IconButton
            key={key}
            id={`id-table-action-${key}`}
            onClick={action.action}
            size='small'
          >
            <img src={action.icon} alt={action.toolTip} style={{ width: 24, height: 24 }} />
          </IconButton>
        </Tooltip>
      ))}
    </>
  );
  return (
    <React.Fragment>
      {renderActionButtons()}
      {showCheckBoxes && (
        <form onSubmit={handleFormSubmit} className='margin-form'>
          <p className='text-left form-txtQuestion'>{lan.questionWhatToSee}</p>
          <div className='row'>{createCheckboxes()}</div>
          <div className='form-group'>
            <div className='row d-flex justify-content-end'>
              <Button type='submit' variant='outlined' onClick={selectAll} className='bntAll'>
                {lan.selectAll}
              </Button>
              <Button type='submit' variant='contained' className='btnSave btn-success'>
                {lan.save}
              </Button>
            </div>
          </div>
        </form>
      )}
    </React.Fragment>
  );
};
export default React.memo(HeaderCheckboxes);
//Original code:
/*import React, { Component } from 'react';
import Checkbox from './Checkbox';
import './HeaderCheckbox.css';
class HeaderCheckboxes extends Component {
	constructor(props) {
		super(props);
		this.state = {
			checkboxes: this.props.totalColums.reduce(
				(options, option) => ({ ...options, [option.key]: this.ObtainKeys(option.key)}), {}
			),
			totalColums: this.props.totalColums,
		};
	}
selectAllCheckboxes = (isSelected) => {
  var i = 0;
  Object.keys(this.state.checkboxes).forEach((checkbox) => {
    var keys = Object.keys(this.state.checkboxes);
    if (keys[i] !== 'iconWarning' && keys[i] !== 'icon') {
      this.setState((prevState) => ({
        checkboxes: { ...prevState.checkboxes, [checkbox]: isSelected },
      }));
    }
    i++;
  });
};
ObtainKeys(keyValue) {
  let cookieObtain = this.props.cookieTable.get(this.props.cookieName);
  if (cookieObtain) {
    return cookieObtain.includes(keyValue);
  } else return undefined;
}
selectAll = () => this.selectAllCheckboxes(true);
handleCheckboxChange = (changeEvent) => {
  const { name } = changeEvent.target;
  const id = document.getElementsByClassName(name)[0].id;
  this.setState((prevState) => ({
    checkboxes: { ...prevState.checkboxes, [id]: !prevState.checkboxes[id] },
  }));
};
handleFormSubmit = (formSubmitEvent) => {
  formSubmitEvent.preventDefault();
  let conca = '';
  Object.keys(this.state.checkboxes)
    .filter((checkbox) => this.state.checkboxes[checkbox])
    .forEach((checkbox) => {
      conca = conca.concat(checkbox + ' ');
    });
  this.props.cookieTable.set(this.props.cookieName, conca.trimRight(), { path: '/' });
  this.props.updateColums();
};
createCheckbox = (option) => {
  if (option.key !== 'iconWarning' && option.key !== 'icon') {
    return (
      <div className='checkbox col-sm-3 d-flex justify-content-start'>
        <Checkbox
          label={option.name} //text rendered next to a checkbox
          isSelected={this.state.checkboxes[option.key]} //tells Checkbox component whether it should render selected or deselected
          onCheckboxChange={this.handleCheckboxChange} //Every time user selects/deselects a checkbox React calls this.handleCheckboxChange function passing change event to it.
          keyN={option.key} // key property that React uses to uniquely identify that instance.
          key={option.key}
        />
      </div>
    );
  }
};
createCheckboxes = () => this.props.totalColums.map(this.createCheckbox);
showModal() {
  this.setState({
    showCheckBoxes: !this.state.showCheckBoxes,
  });
}
actionButtons = () => {
  return (
    <div className='row justify-content-end'>
      {this.props.customActions != null
        ? this.props.customActions.map((action, key) => {
          return (
            <button
              key={key}
              id={'id-table-action-' + key}
              type='button'
              onClick={action.action}
              className='btn'
              title={action.toolTip}
              style={{ border: 'none'}}
            >
              <img src={action.icon} alt='' />
            </button>
          );
        })
        : ''}
    </div>
  );
};
render() {
  return (
    <React.Fragment>
      <Grid container direction='row' justifyContent='flex-end'>
        <Grid size='auto'>
          <this.actionButtons />
        </Grid>
      </Grid>
      {this.state.showCheckBoxes ? (
        <form onSubmit={this.handleFormSubmit} className='margin-form'>
          <p className='text-left form-txtQuestion'>{this.props.lan.questionWhatToSee}</p>
          <div className='row'>{this.createCheckboxes()}</div>
          <div className='form-group'>
            <div className='row d-flex justify-content-end'>
              <div className='col d-flex justify-content-end'>
                {
                  <button
                    type='submit'
                    className='btn btn-outline-primary bntAll'
                    onClick={this.selectAll}
                  >
                    {this.props.lan.selectAll}
                  </button>
                }
              </div>
              <div className='margin-btnSave'>
                <button type='submit' className='btn btn-outline-primary btnSave btn-success'>
                  {this.props.lan.save}
                </button>
              </div>
            </div>
          </div>
        </form>
      ) : null}
    </React.Fragment>
  );
}
}
export default React.memo(HeaderCheckboxes);
*/
